import {Grid} from '@primer/react-brand'

import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {GenericSectionWithIds} from '../../../brand/lib/types/contentful'
import {BrandPage, usePage} from '../../../brand/components/BrandPage'

import {FeaturesSection} from './_sections/FeaturesSection/FeaturesSection'
import {HeroSection} from './_sections/HeroSection/HeroSection'
import {OrganizationSection} from './_sections/OrganizationSection/OrganizationSection'
import {PricingSection} from './_sections/PricingSection/PricingSection'
import {ResourcesSection} from './_sections/ResourcesSection/ResourcesSection'
import {WorkflowSection} from './_sections/WorkflowSection/WorkflowSection'

import {PlanTypeContextProvider} from './_context/PlanTypeContext'

import styles from './styles.module.css'

function PageContent() {
  const isUniverseEnabled = isFeatureEnabled('site_features_copilot_universe')

  const page = usePage()

  const {
    featuresCopilotFeaturesSection,
    featuresCopilotHeroSection,
    featuresCopilotOrganizationSection,
    featuresCopilotPricingSection,
    featuresCopilotResourcesSection,
    featuresCopilotWorkflowSection,
  } = page.ids as {
    featuresCopilotFeaturesSection: GenericSectionWithIds
    featuresCopilotHeroSection: GenericSectionWithIds
    featuresCopilotOrganizationSection: GenericSectionWithIds
    featuresCopilotPricingSection: GenericSectionWithIds
    featuresCopilotResourcesSection: GenericSectionWithIds
    featuresCopilotWorkflowSection: GenericSectionWithIds
  }

  return (
    <PlanTypeContextProvider>
      <Grid>
        <Grid.Column span={12}>
          {featuresCopilotHeroSection ? <HeroSection contentfulContent={featuresCopilotHeroSection} /> : null}

          {!isUniverseEnabled && featuresCopilotFeaturesSection ? (
            <FeaturesSection contentfulContent={featuresCopilotFeaturesSection} />
          ) : null}

          {isUniverseEnabled && featuresCopilotWorkflowSection ? (
            <WorkflowSection contentfulContent={featuresCopilotWorkflowSection} />
          ) : null}

          {isUniverseEnabled && featuresCopilotOrganizationSection ? (
            <OrganizationSection contentfulContent={featuresCopilotOrganizationSection} />
          ) : null}

          {featuresCopilotPricingSection ? <PricingSection contentfulContent={featuresCopilotPricingSection} /> : null}

          {featuresCopilotResourcesSection ? (
            <ResourcesSection contentfulContent={featuresCopilotResourcesSection} />
          ) : null}
        </Grid.Column>
      </Grid>
    </PlanTypeContextProvider>
  )
}

export default function FeaturesCopilotIndex() {
  return (
    <BrandPage pageClassName={styles.page} subnavClassName={styles.subnav}>
      <PageContent />
    </BrandPage>
  )
}

try{ PageContent.displayName ||= 'PageContent' } catch {}
try{ FeaturesCopilotIndex.displayName ||= 'FeaturesCopilotIndex' } catch {}